<div class="outer-table-container flex">
  <div class="company-names">
    <div class="header flex-2">
      <span>Name</span>
      @if (!hideSorting) {
        <button
          mat-icon-button
          (click)="onSortClick(nameSortKey); $event.preventDefault()"
          class="sorting-button"
          [class.sort-visible]="!!sorting[nameSortKey]"
        >
          <mat-icon>{{
            !sorting[nameSortKey]
              ? "swap_vert"
              : sorting[nameSortKey] == "asc"
                ? "north"
                : "south"
          }}</mat-icon>
        </button>
      }
    </div>
    @for (item of list; track trackByAsset(i, item); let i = $index) {
      <div
        class="asset-row"
        [class.grey]="i % 2 === 0"
        [class.white]="i % 2 === 1"
        [class.disabled-row]="simpleMode && item.disabled"
      >
        <div class="width-50"></div>
        <div class="asset-col flex-2">
          <div class="d-flex h-100 align-items-center">
            <div class="width-50">
              @if (!hideSelect) {
                <mat-checkbox
                  color="primary"
                  [checked]="item.selected"
                  [disabled]="simpleMode && item.disabled"
                  [matTooltip]="simpleMode ? item.disabledTooltip || '' : ''"
                  (change)="onSelect($event, item)"
                ></mat-checkbox>
              }
            </div>
            @if (simpleMode) {
              <div class="company-name">
                <span>{{ item[nameProp] }}</span>
              </div>
              <div class="company-name">
                @if (item[descriptionProp]) {
                  <app-info-popover
                    [company]="item"
                    [title]="'Description - ' + item[nameProp]"
                    [content]="item[descriptionProp]"
                    (click)="closeOtherCompanies(item)"
                  ></app-info-popover>
                }
              </div>
            } @else {
              <div class="company-name">
                <!-- <span class="underline-on-hover" (click)="onCompanyInfoClick(item)">{{item.company_name}}</span> -->
                <span
                  class="underline-on-hover"
                  (click)="onCompanyInfoClick(item)"
                  >{{ item.company_name }}
                </span>
                @if (item.data_lag_days != null && item.data_lag_days > 7) {
                  <span
                    class="stale-badge"
                    [title]="
                      'Last close: ' +
                      (item.last_data_date || 'unknown') +
                      ' (' +
                      item.data_lag_days +
                      ' days behind)'
                    "
                    >data {{ item.data_lag_days }}d stale</span
                  >
                }
              </div>
              <div class="company-name">
                @if (item.overview && item.overview.description) {
                  <app-info-popover
                    [company]="item"
                    [highlight]="currentFilters.searchTerm"
                    [title]="'Description - ' + item.company_name"
                    [content]="item.overview.description"
                    (click)="closeOtherCompanies(item)"
                  ></app-info-popover>
                }
                @if (item.etf_reference_table && item.etf_reference_table.descr) {
                  <app-info-popover
                    [company]="item"
                    [highlight]="currentFilters.searchTerm"
                    [title]="'Description - ' + item.company_name"
                    [content]="item.etf_reference_table.descr"
                    (click)="closeOtherCompanies(item)"
                  ></app-info-popover>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="big-container table-container fake-table" id="asset-tbl">
    <div
      class="headers"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
    >
      @for (f of quantList; track trackByColumn($index, f)) {
        <div
          class="header"
          [class.flex-2]="(columnsEnum[f.id] && columnsEnum[f.id].double) || (simpleMode && f.double)"
          [class.col-small]="(columnsEnum[f.id] && columnsEnum[f.id].colSmall) || (simpleMode && f.colSmall)"
          [class.col-large]="(columnsEnum[f.id] && columnsEnum[f.id].colLarge) || (simpleMode && f.colLarge)"
          cdkDrag
        >
          <div class="header-placeholder" *cdkDragPlaceholder></div>
          @if (simpleMode) {
            <div class="header flexed" [class.text-end]="f.align === 'end'">
              <span class="header-title">{{ f.title }}</span>
              @if (f.sortable && !hideSorting) {
                <button
                  mat-icon-button
                  (click)="onSortClick(f.sortKey || f.id); $event.preventDefault()"
                  class="sorting-button align-end"
                  [class.sort-visible]="sorting[f.sortKey || f.id]"
                >
                  <mat-icon>{{
                    !sorting[f.sortKey || f.id]
                      ? "swap_vert"
                      : sorting[f.sortKey || f.id] == "asc"
                        ? "north"
                        : "south"
                  }}</mat-icon>
                </button>
              }
            </div>
          }
          @if (!simpleMode && columnsEnum[f.id]) {
            <div>
              @if (
                !columnsEnum[f.id].headerFilter &&
                !columnsEnum[f.id].menuFilter &&
                !columnsEnum[f.id].headerSelect
              ) {
                <div class="header-title">
                  {{ columnsEnum[f.id].title }}
                </div>
              }
              @if (columnsEnum[f.id].headerFilter) {
                <div
                  class="header flexed"
                  [class.text-end]="columnsEnum[f.id].textRight"
                >
                  <app-asset-table-header-filter
                    [title]="columnsEnum[f.id].title"
                    [class.text-end]="columnsEnum[f.id].textAlign"
                    [unit]="columnsEnum[f.id].unit"
                    [minModel]="columnsEnum[f.id].model$gt"
                    [maxModel]="columnsEnum[f.id].model$lt"
                    (minModelChanged)="
                      onNumberFilterChange(
                        columnsEnum[f.id].value,
                        '$gt',
                        $event
                      )
                    "
                    (maxModelChanged)="
                      onNumberFilterChange(
                        columnsEnum[f.id].value,
                        '$lt',
                        $event
                      )
                    "
                    (enterHit)="onFetchCompanies()"
                  ></app-asset-table-header-filter>
                  @if (!hideSorting && columnsEnum[f.id].sorting) {
                    <button
                      mat-icon-button
                      (click)="
                        onSortClick(columnsEnum[f.id].value);
                        $event.preventDefault()
                      "
                      class="sorting-button align-end"
                      [class.sort-visible]="sorting[columnsEnum[f.id].value]"
                    >
                      <mat-icon>{{
                        !sorting[columnsEnum[f.id].value]
                          ? "swap_vert"
                          : sorting[columnsEnum[f.id].value] == "asc"
                            ? "north"
                            : "south"
                      }}</mat-icon>
                    </button>
                  }
                </div>
              }
              @if (columnsEnum[f.id].menuFilter) {
                <div
                  class="header flexed"
                  [class.text-end]="columnsEnum[f.id].textRight"
                >
                  <span
                    [matMenuTriggerFor]="menu"
                    class="input-filter-header text-end"
                    >{{ columnsEnum[f.id].title }}</span
                  >
                  <mat-menu
                    #menu="matMenu"
                    [overlapTrigger]="false"
                    class="input-menu"
                  >
                    <div mat-menu-item [disableRipple]="true">
                      <div class="row">
                        <div class="col-6">
                          <app-cim-datepicker
                            (click)="$event.stopPropagation()"
                            label="Start date"
                            [model]="columnsEnum[f.id].model$gt"
                            [isFullWidth]="true"
                            (modelChanged)="
                              onNumberFilterChange(
                                columnsEnum[f.id].value,
                                '$gt',
                                $event,
                                true
                              )
                            "
                          ></app-cim-datepicker>
                        </div>
                        <div class="col-6">
                          <app-cim-datepicker
                            (click)="$event.stopPropagation()"
                            label="End date"
                            [model]="columnsEnum[f.id].model$lt"
                            [isFullWidth]="true"
                            (modelChanged)="
                              onNumberFilterChange(
                                columnsEnum[f.id].value,
                                '$lt',
                                $event,
                                true
                              )
                            "
                          ></app-cim-datepicker>
                        </div>
                      </div>
                    </div>
                  </mat-menu>
                  @if (!hideSorting) {
                    <button
                      mat-icon-button
                      (click)="
                        onSortClick(columnsEnum[f.id].value);
                        $event.preventDefault()
                      "
                      class="sorting-button align-end"
                      [class.sort-visible]="sorting[columnsEnum[f.id].value]"
                    >
                      <mat-icon>{{
                        !sorting[columnsEnum[f.id].value]
                          ? "swap_vert"
                          : sorting[columnsEnum[f.id].value] == "asc"
                            ? "north"
                            : "south"
                      }}</mat-icon>
                    </button>
                  }
                </div>
              }
              @if (columnsEnum[f.id].headerSelect) {
                <div
                  class="header flexed"
                  [class.text-end]="columnsEnum[f.id].textRight"
                >
                  <app-table-header-select
                    [isInTableHeader]="true"
                    labelPrefix=""
                    [label]="columnsEnum[f.id].title"
                    [isMultiple]="true"
                    [isFullWidth]="true"
                    [list]="filterLists[columnsEnum[f.id].list]"
                    [model]="getCurrentFilters[columnsEnum[f.id].model]"
                    (modelChanged)="
                      onSelectFilterChange(columnsEnum[f.id].value, $event)
                    "
                    (panelClosed)="onFetchCompanies()"
                    [name]="columnsEnum[f.id].value"
                  ></app-table-header-select>
                  @if (!hideSorting) {
                    <button
                      mat-icon-button
                      (click)="
                        onSortClick(columnsEnum[f.id].value);
                        $event.preventDefault()
                      "
                      class="sorting-button"
                      [class.align-end]="columnsEnum[f.id].textRight"
                      [class.sort-visible]="sorting.region_list_name"
                    >
                      <mat-icon>{{
                        !sorting[columnsEnum[f.id].value]
                          ? "swap_vert"
                          : sorting[columnsEnum[f.id].value] == "asc"
                            ? "north"
                            : "south"
                      }}</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          }
          @if (!simpleMode && !columnsEnum[f.id]) {
            <div>
              @if (!f.default) {
                <span>
                  @if (!f.filterType) {
                    <div class="flexed text-end">
                      <app-asset-table-header-filter
                        [title]="f.shortName"
                        [unit]="f.unit"
                        [minModel]="currentFilters.dynamic[f.id + '$gt']"
                        [maxModel]="currentFilters.dynamic[f.id + '$lt']"
                        (minModelChanged)="
                          onNumberFilterChange(f.id, '$gt', $event)
                        "
                        (maxModelChanged)="
                          onNumberFilterChange(f.id, '$lt', $event)
                        "
                        (enterHit)="onFetchCompanies()"
                      >
                      </app-asset-table-header-filter>
                      @if (!hideSorting) {
                        <button
                          mat-icon-button
                          (click)="onSortClick(f.id); $event.preventDefault()"
                          class="sorting-button align-end"
                          [class.sort-visible]="sorting[f.id]"
                        >
                          <mat-icon>{{
                            !sorting[f.id]
                              ? "swap_vert"
                              : sorting[f.id] == "asc"
                                ? "north"
                                : "south"
                          }}</mat-icon>
                        </button>
                      }
                    </div>
                  }
                  @if (f.filterType) {
                    <div class="flexed text-end">
                      <!-- Credit rating multiselect filter -->
                      <app-table-header-select
                        [isInTableHeader]="true"
                        labelPrefix=""
                        [label]="f.name"
                        [isMultiple]="true"
                        [isFullWidth]="true"
                        [hideMarked]="true"
                        [list]="filterLists[f.filterType]"
                        [model]="currentFilters.dynamic[f.id + '$in']"
                        (modelChanged)="
                          onDynamicSelectFilterChange(f.id, $event)
                        "
                        (panelClosed)="onFetchCompanies()"
                      ></app-table-header-select>
                      @if (!hideSorting) {
                        <button
                          mat-icon-button
                          (click)="onSortClick(f.id); $event.preventDefault()"
                          class="sorting-button"
                          [class.sort-visible]="sorting[f.id]"
                        >
                          <mat-icon>{{
                            !sorting[f.id]
                              ? "swap_vert"
                              : sorting[f.id] == "asc"
                                ? "north"
                                : "south"
                          }}</mat-icon>
                        </button>
                      }
                    </div>
                  }
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
    @for (item of list; track trackByAsset(i, item); let i = $index) {
      <div
        class="asset-row"
        [class.grey]="i % 2 === 0"
        [class.white]="i % 2 === 1"
        [class.disabled-row]="simpleMode && item.disabled"
      >
        @for (f of quantList; track trackByColumn($index, f)) {
          <div
            class="asset-col"
            [class.number-col]="
              f.decimalInfo || f.class === 'date' || f.class === 'code'
            "
            [class.text-end]="
              simpleMode ? f.align === 'end' : isRightAligned(item, f.id)
            "
            [class.flex-2]="(columnsEnum[f.id] && columnsEnum[f.id].double) || (simpleMode && f.double)"
            [class.col-small]="(columnsEnum[f.id] && columnsEnum[f.id].colSmall) || (simpleMode && f.colSmall)"
            [class.col-large]="(columnsEnum[f.id] && columnsEnum[f.id].colLarge) || (simpleMode && f.colLarge)"
          >
            @if (simpleMode) {
              <div>
                @switch (f.cellType) {
                  @case ("icon") {
                    <mat-icon
                      [style.color]="item[f.colValue]?.color"
                      [matTooltip]="item[f.colValue]?.tooltip || ''"
                    >
                      {{ item[f.colValue]?.icon }}
                    </mat-icon>
                  }
                  @case ("number") {
                    <span>{{
                      item[f.colValue] != null
                        ? (item[f.colValue] | number: "1.0-0")
                        : "-"
                    }}</span>
                  }
                  @case ("date") {
                    <span>{{
                      item[f.colValue]
                        ? (item[f.colValue] | utcToLocalTime: "short")
                        : "-"
                    }}</span>
                  }
                  @default {
                    <span>{{ item[f.colValue] ?? "-" }}</span>
                  }
                }
              </div>
            }
            @if (!simpleMode && columnsEnum[f.id]) {
              <div>
                @if (columnsEnum[f.id].colType === "number") {
                  <div>
                    <span
                      [matTooltip]="
                        item[columnsEnum[f.id].colValue] > -1 &&
                        item[columnsEnum[f.id].colValue] < 1
                          ? item[columnsEnum[f.id].colValue].toFixed(2)
                          : ''
                      "
                    >
                      {{ item[columnsEnum[f.id].colValue] | number: "1.0-0" }}
                    </span>
                  </div>
                }
                @if (columnsEnum[f.id].colType !== "number") {
                  <div>
                    @if (columnsEnum[f.id].colValue) {
                      <div [class.text-start]="!columnsEnum[f.id].textRight">
                        <span
                          [matTooltip]="
                            +item[columnsEnum[f.id].colValue] > -1 &&
                            +item[columnsEnum[f.id].colValue] < 1
                              ? (+item[columnsEnum[f.id].colValue]).toFixed(2)
                              : ''
                          "
                        >
                          {{ item[columnsEnum[f.id].colValue] }}
                        </span>
                      </div>
                    }
                  </div>
                }
                @if (columnsEnum[f.id].colDeep) {
                  <div>
                    {{ resolveDeepValue(item, columnsEnum[f.id].colDeep) }}
                  </div>
                }
                @if (!columnsEnum[f.id].colDeep && !columnsEnum[f.id].colType) {
                  <div [class.text-start]="!columnsEnum[f.id].textRight">
                    <span>
                      {{
                        item[filterProp]
                          ? (item[filterProp][f.id]
                            | optionalNumber: f.decimalInfo)
                          : ""
                      }}
                      @if (
                        item[filterProp][f.id] !== null &&
                        f.unit &&
                        f.unit == "%"
                      ) {
                        <small>{{ f.unit }}</small>
                      }
                    </span>
                  </div>
                }
              </div>
            }
            @if (!simpleMode && !columnsEnum[f.id]) {
              <div>
                <span
                  [matTooltip]="
                    +item[filterProp][f.id] > -1 && +item[filterProp][f.id] < 1
                      ? (+item[filterProp][f.id]).toFixed(2)
                      : ''
                  "
                >
                  {{
                    item[filterProp]
                      ? (item[filterProp][f.id] | optionalNumber: f.decimalInfo)
                      : ""
                  }}
                  @if (
                    item[filterProp][f.id] !== null && f.unit && f.unit == "%"
                  ) {
                    <small>{{ f.unit }}</small>
                  }
                </span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
